export type Language = 'fr' | 'en'

export interface Translation {
  nav: {
    features: string
    results: string
    cases: string
    home: string
    main: string
    mobile: string
    openMenu: string
    closeMenu: string
    changeLanguage: string
  }
  cta: {
    login: string
    demo: string
  }
  hero: {
    highlight: string
    titleRest: string
    subtitleBefore: string
    subtitleStrong: string
    subtitleAfter: string
    demoDuration: string
  }
  socialProof: {
    usedBy: string
    managers: string
    on: string
  }
  logos: {
    label: string
  }
  showcase: {
    sectionLabel: string
    play: string
    previewAlt: string
    dialogLabel: string
    iframeTitle: string
    loading: string
    close: string
  }
  footer: {
    text: string
  }
}

export const translations: Record<Language, Translation> = {
  fr: {
    nav: {
      features: 'Fonctionnalités',
      results: 'Résultats',
      cases: 'Cas client',
      home: 'Accueil Rewayz',
      main: 'Navigation principale',
      mobile: 'Navigation mobile',
      openMenu: 'Ouvrir le menu',
      closeMenu: 'Fermer le menu',
      changeLanguage: 'Changer de langue'
    },
    cta: {
      login: 'Se connecter',
      demo: 'Réserver une démo'
    },
    hero: {
      highlight: 'Le copilote IA',
      titleRest: 'qui aide vos managers à prendre les bonnes décisions',
      subtitleBefore: 'Détectez les signaux faibles de vos équipes,',
      subtitleStrong: 'guidez vos managers vers les bonnes actions',
      subtitleAfter: 'pour les aider à mieux performer au quotidien',
      demoDuration: 'Démo de 30 minutes'
    },
    socialProof: {
      usedBy: 'Utilisé par',
      managers: '+5000 managers',
      on: 'sur'
    },
    logos: {
      label: 'Ils nous font confiance'
    },
    showcase: {
      sectionLabel: 'Vidéo de démonstration Rewayz',
      play: 'Lire la vidéo de démonstration',
      previewAlt: "Aperçu de l'interface Rewayz : recommandation d'action pour un manager",
      dialogLabel: 'Démonstration Rewayz',
      iframeTitle: 'Démonstration interactive Rewayz',
      loading: 'Chargement de la démonstration…',
      close: 'Fermer'
    },
    footer: {
      text: '© Rewayz 2026 - Tous droits réservés — ( 🚧 site en construction)'
    }
  },
  en: {
    nav: {
      features: 'Features',
      results: 'Results',
      cases: 'Customer stories',
      home: 'Rewayz home',
      main: 'Main navigation',
      mobile: 'Mobile navigation',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      changeLanguage: 'Change language'
    },
    cta: {
      login: 'Log in',
      demo: 'Book a demo'
    },
    hero: {
      highlight: 'The AI copilot',
      titleRest: 'that helps your managers make the right decisions',
      subtitleBefore: 'Spot the weak signals in your teams,',
      subtitleStrong: 'guide your managers toward the right actions',
      subtitleAfter: 'and help them perform better every day',
      demoDuration: '30-minute demo'
    },
    socialProof: {
      usedBy: 'Used by',
      managers: '5,000+ managers',
      on: 'on'
    },
    logos: {
      label: 'They trust us'
    },
    showcase: {
      sectionLabel: 'Rewayz demo video',
      play: 'Play the demo video',
      previewAlt: 'Preview of the Rewayz interface: an action recommendation for a manager',
      dialogLabel: 'Rewayz demo',
      iframeTitle: 'Rewayz interactive demo',
      loading: 'Loading the demo…',
      close: 'Close'
    },
    footer: {
      text: '© Rewayz 2026 - All rights reserved — ( 🚧 site under construction)'
    }
  }
}
